export default [
  {
    path: '/inquiry/study',
    name: 'inquiryStudy',
    component: () => import(/* webpackChunkName: "booksGuideApp" */'@/views/inquiry/inquiry-study.vue'),
  },
  {
    path: '/inquiry/reading',
    name: 'inquiryReading',
    component: () => import(/* webpackChunkName: "booksGuideApp" */'@/views/inquiry/inquiry-reading.vue'),
  }
]
